@if (data.formGroup.errors) {
  <div class="form--error--wrapper" [ngClass]="{'form--error--wrapper_vibible': true}">
    <nx-error nxFormfieldError>
      @if (data.formData.showOnlyFirstError) {
        @let field = (data.formGroup.errors | arrayKeys)[0];
        @let error = data.formGroup.errors[field][0];
        <span class="form--error--text">
          {{
            data.formData.customErrorLabel?.[field]?.[error] ??
              'azForm.errors.' + field + '.' + error | translate
          }}
        </span>
      } @else {
        @for (field of data.formGroup.errors | arrayKeys; track $index) {
          @for (error of data.formGroup.errors[field]; track $index) {
            <span class="form--error--text">
              {{
                data.formData.customErrorLabel?.[field]?.[error] ??
                  'azForm.errors.' + field + '.' + error | translate
              }}
            </span>
          }
        }
      }
    </nx-error>
  </div>
}
